import React from 'react';

const CaseTimeline = ({ timelineEvents = [] }) => {
    const formatActor = (actor) => {
        if (!actor) return null;
        if (typeof actor === 'string') return actor;
        if (typeof actor === 'object') {
            const displayName = actor.name || actor.email || actor.id;
            if (!displayName) return null;
            if (actor.id && displayName !== actor.id) return `${displayName} (${actor.id})`;
            return displayName;
        }
        return String(actor);
    };

    return (
        <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
            <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex justify-between items-center">
                <h4 className="text-lg font-bold text-gray-400 uppercase tracking-wider flex items-center gap-2">
                    🕒 SYSTEM LOG (TIMELINE)
                </h4>
            </div>
            <div className="p-4 max-h-96 overflow-y-auto">
                {timelineEvents.length === 0 && (
                    <div className="text-center py-8 text-gray-500 font-mono uppercase">No recent activity</div>
                )}
                {timelineEvents.length > 0 && (
                    <ul className="space-y-0 relative border-l border-gray-700 ml-3">
                        {timelineEvents.map((e, idx) => (
                            <li key={idx} className="mb-4 pl-6 relative group">
                                <div className={`absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full border-2 border-gray-800 ${e.type.includes('stage') ? 'bg-blue-500' : e.type.includes('completed') ? 'bg-green-500' : 'bg-gray-500'}`}></div>
                                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1">
                                    <div className="flex items-center gap-2">
                                        <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold uppercase border ${e.type.includes('stage') ? 'bg-blue-900/30 text-blue-400 border-blue-800' : e.type.includes('completed') ? 'bg-green-900/30 text-green-400 border-green-800' : 'bg-gray-700 text-gray-400 border-gray-600'}`}>
                                            {e.type.replace('_', ' ')}
                                        </span>
                                        <span className="text-sm text-gray-300 font-mono">{e.text}</span>
                                    </div>
                                    <div className="text-xs text-gray-500 font-mono uppercase">
                                        {new Date(e.at).toLocaleString()}
                                    </div>
                                </div>
                                {formatActor(e.actor) && (
                                    <div className="text-[10px] text-gray-600 font-mono mt-1 uppercase">
                                        BY: <span className="text-gray-400">{formatActor(e.actor)}</span>
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default CaseTimeline;
